/**
 * Intentionally free materials (craftsman shake cutoffs and similar).
 * `zero_cost_cutoff` is the key the craftsman seed already writes.
 * The material form writes `allow_zero_cost`.
 */

export function materialAllowsZeroCost(metadata: unknown): boolean {
  if (!metadata || typeof metadata !== "object") return false;
  const meta = metadata as Record<string, unknown>;
  return meta.allow_zero_cost === true || meta.zero_cost_cutoff === true;
}

export function mergeAllowZeroCostMetadata(
  existing: Record<string, unknown>,
  allowed: boolean,
): Record<string, unknown> {
  const next = { ...existing };
  if (allowed) {
    next.allow_zero_cost = true;
    return next;
  }
  delete next.allow_zero_cost;
  delete next.zero_cost_cutoff;
  return next;
}
